import script from "./LoadingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingModal.vue?vue&type=script&setup=true&lang=js"

import "./LoadingModal.vue?vue&type=style&index=0&id=1238e394&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1238e394"]])

export default __exports__